import helpers from '../util/helpers';

export default {
  init() {

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // Hotel Booking Form onSubmit
    // $('.hotel-booking-form').submit(function(e) {
    //   if ($(this).find('input.check-in').val().toLowerCase() === '' || $(this).find('input.check-out').val().toLowerCase() === '') {
    //     $(this).find('.date-validator').show();
    //     e.preventDefault();
    //   } else {
    //     $(this).find('.date-validator').hide();
    //   }
    // });

    // Slick room sliders
    const roomSlider = $('.section-hotel-hp-detail-booking .rooms-slider');
    if (roomSlider.length) {
      roomSlider.on('init', function() {
        helpers.equalHeightElements('.rooms-slider .equal-height');
      });

      roomSlider.slick({
        dots: false,
        arrows: true,
        appendArrows: roomSlider.siblings().find('.slider-nav'),
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 991,
            settings: 'unslick',
          },
        ],
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateHotelDiningPage.js